<!--  ############### Header Start ################# close-->  
  <header>
      <div class="hamburger">
        <span [ngClass]="{ close: isMenuOpen }" (click)="toggleMenu()">
          <div class="bar1"></div>
          <div class="bar2"></div>
          <div class="bar3"></div>
        </span>
      </div>
      <div class="logo"><a href="{{homeUrl}}"><img src="assets/liside_logo.png" alt="ManpowerGroup Logo"></a></div>
      <div class="header_content">
        
        <h1>{{ titleKey | translate }}</h1>
        <div class="header_right">
              <ul>
                  <li>
                    <label class="lang_switch">
                      <input type="checkbox" 
                      [(ngModel)]="markedLanguage" 
                      (change)="cngLang()">
                      <span class="slider">
                        <s>JP</s><s>EN</s>
                      </span>
                    </label>
                  </li>
                  <li *ngIf="userRole !== 'Client'">
                      <div class="header_butn user_code">
                          <strong>{{"UserCode" | translate}} :</strong>
                          <span>{{userCode}}</span>
                      </div>
                  </li>
                  <li>
                      <div class="header_butn profile_dropdown">
                          <strong>{{userName}} </strong>
                          <ul class="drop_down_item">
                            <!-- data-bs-toggle="modal" 
                            data-bs-target="#cngEmail" -->
                              <li *ngIf="manageEmail?.includes(userRole)">
                                <a class="dropdown-item" 
                                href="javascript:void(0)"                                        
                                (click)="genEmailPop()">{{'EDITEMAIL' | translate}}</a></li>
                              <li *ngIf="managePassword?.includes(userRole)"><a class="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#cngPassword">{{'CHANGEPASSWORD' | translate}}</a></li>
                              <li><a class="dropdown-item" href="javascript:void(0)" (click)="logout()">{{'LOGOUT' | translate}}</a></li>
                          </ul>
                      </div>
                  </li>
              </ul>

          </div>
      </div>
   </header>
  <!--  ############### Header End ################# -->
  

<!-- ################# Change password pop up ######################## -->
<div class="modal fade" id="cngPassword" tabindex="-1" aria-labelledby="exampleModalLabel" data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true">
  <div class="modal-dialog modal-lg custom_modal">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="exampleModalLabel">{{'CHANGEPASSWORD' | translate}}</h3>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <form [formGroup]="frmChangePassword">
      <div class="modal-body">
             <input type="text" name="username" autocomplete="username" style="display:none" aria-hidden="true">
             <div class="mb-3 row">
                  <label for="password" class="col-sm-4 col-form-label">{{'CngPassword.OLDPASSWORD' | translate}}</label>
                  <div class="col-sm-8">
                      <input type="password" class="form-control" id="password" formControlName="password"
                      name="password" required aria-describedby="password" autocomplete="current-password" placeholder="{{'CngPassword.OLDPASSWORD' | translate}}">
                      <!-- <span><i class="bi bi-eye-slash"></i></span> -->
                      <small *ngIf="frmChangePassword.controls['password'].dirty && frmChangePassword.hasError('required','password')" class="text-danger mt-1">*{{'CngPassword.err1' | translate}}</small>
                  </div>
              </div>
              <div class="mb-3 row">
                  <label for="newPassword" class="col-sm-4 col-form-label">{{'CngPassword.NEWPASSWORD' | translate}}</label>
                  <div class="col-sm-8">
                      <input [type]="type" class="form-control" id="newPassword" formControlName="newPassword" name="newPassword" aria-describedby="newPassword" autocomplete="new-password" placeholder="{{'CngPassword.NEWPASSWORD' | translate}}">
                      <!-- <span class="eye-slash"><i class="bi {{eyeIcon}}" (click)="hideShowPass()"></i></span> -->
                      <!-- <small *ngIf="frmChangePassword.controls['newPassword'].dirty && frmChangePassword.hasError('required','newPassword')" class="text-danger mt-1">*{{'CngPassword.err2' | translate}}</small> -->
                      <small *ngIf="frmChangePassword.controls['newPassword'].dirty && frmChangePassword.hasError('required','newPassword')" class="text-danger mt-1">*{{"ResetPassword.err1" | translate}}</small>
                      <small *ngIf="frmChangePassword.get('newPassword')?.errors?.['minlength']"  class="text-danger mt-1">{{'CngPassword.err3' | translate}}&nbsp;</small>
                      <small *ngIf="frmChangePassword.get('newPassword')?.errors?.['alphanumeric']"  class="text-danger mt-1">{{'CngPassword.err6' | translate}}</small>
                  </div>
              </div>
              <div class="mb-3 row">
                  <label for="retypePassword" class="col-sm-4 col-form-label">{{'CngPassword.RETYPEPASSWORD' | translate}}</label>
                  <div class="col-sm-8">
                      <input [type]="type" class="form-control" id="retypePassword" formControlName="retypePassword" name="retypePassword" aria-describedby="retypePassword" autocomplete="new-password" placeholder="{{'CngPassword.RETYPEPASSWORD' | translate}}"
                      (copy)="$event.preventDefault()"
                      (paste)="$event.preventDefault()">                     
                       <!-- <div class="text-danger" *ngIf="frmChangePassword.controls['retypePassword'].touched && frmChangePassword.controls['retypePassword'].errors">
                        <div *ngIf="frmChangePassword.get('retypePassword')?.errors?.['required']">{{'CngPassword.err4' | translate}}</div>
                        <div *ngIf="frmChangePassword.get('retypePassword')?.errors?.['mismatch']">{{'CngPassword.err5' | translate}}</div>
                      </div> -->
                      <small *ngIf="frmChangePassword.controls['retypePassword'].dirty && frmChangePassword.hasError('required','retypePassword')" class="text-danger mt-1">*{{"ResetPassword.err2" | translate}}</small>
                      <small *ngIf="frmChangePassword.get('retypePassword')?.errors?.['mismatch']" class="text-danger mt-1">*{{'CngPassword.err5' | translate}}</small>
                  </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" (click)="changePassword()">{{'UPDATEBTN' | translate}}</button>
              <button #btncngPassword type="button" class="btn btn-secondary" data-bs-dismiss="modal" id="btncngPassword">{{'CLOSEBTN' | translate}}</button>
            </div>
          </form>
    </div>
  </div>
</div>

<!-- ################# Change email pop up ######################## -->
<div class="modal fade" id="cngEmail" tabindex="-1" aria-labelledby="exampleModalLabel1" data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true">
  <div class="modal-dialog modal-lg custom_modal">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="exampleModalLabel">{{'CngMail.CHANGEEMAIL' | translate}}</h3>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <form [formGroup]="frmChangeEmail"><!--NOTETEXT,LINKTEXT -->
      <div class="modal-body">
              <div class="mb-3 row">
                  <label for="registeredEmail" class="col-sm-4 col-form-label">{{'CngMail.REGMAIL' | translate}}</label>
                  <div class="col-sm-8">
                      <input type="email" class="form-control" id="registeredEmail" formControlName="registeredEmail"
                      name="registeredEmail" aria-describedby="registeredEmail" placeholder="{{'CngMail.REGMAIL' | translate}}" readonly>                   
                      <small *ngIf="frmChangeEmail.controls['registeredEmail'].dirty && frmChangeEmail.hasError('required','registeredEmail')" class="text-danger mt-1">*{{'CngMail.err1' | translate}}</small>
                  </div>
              </div>
              <div class="mb-3 row">
                  <label for="notificationEmail" class="col-sm-4 col-form-label">{{'CngMail.NEWEMAIL' | translate}}</label>
                  <div class="col-sm-8">
                      <input type="text" class="form-control" id="notificationEmail" formControlName="notificationEmail" name="notificationEmail" aria-describedby="notificationEmail" placeholder="{{'CngMail.NEWEMAIL' | translate}}">                      
                      <small class="text-danger mt-1" *ngIf="frmChangeEmail.controls['notificationEmail'].dirty && frmChangeEmail.hasError('required','notificationEmail')" >*{{'CngMail.err2' | translate}}</small>
                      <small *ngIf="
                        frmChangeEmail.get('notificationEmail')?.touched &&
                        frmChangeEmail.get('notificationEmail')?.errors?.['pattern']
                      " class="text-danger mt-1">
                        {{ 'CngMail.err5' | translate }}
                      </small>
                      <small class="text-danger mt-1" *ngIf="frmChangeEmail.get('notificationEmail')?.errors?.['samemail']">
                        {{ 'CngMail.err6' | translate }}
                      </small>
                  </div>
              </div>
              <div class="mb-3 row">
                  <label for="retypeNotificationEmail" class="col-sm-4 col-form-label">{{'CngMail.RETYPEEMAIL' | translate}}</label>
                  <div class="col-sm-8">
                      <input type="text" class="form-control" id="retypeNotificationEmail" formControlName="retypeNotificationEmail" name="retypeNotificationEmail" aria-describedby="retypeNotificationEmail" placeholder="{{'CngMail.RETYPEEMAIL' | translate}}" (copy)="$event.preventDefault()"
                      (paste)="$event.preventDefault()">

                      <div class="text-danger"
                        *ngIf="frmChangeEmail.get('retypeNotificationEmail')?.touched">
                      <!-- Required -->
                      <div *ngIf="frmChangeEmail.get('retypeNotificationEmail')?.errors?.['required']">
                        {{ 'CngMail.err3' | translate }}
                      </div>
                      <!-- Mismatch -->
                      <div *ngIf="frmChangeEmail.get('retypeNotificationEmail')?.errors?.['mismatch']">
                        {{ 'CngMail.err4' | translate }}
                      </div>

                    </div>
                  </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" (click)="changeEmail()">{{'UPDATEBTN' | translate}}</button>
              <button #btncngEmail type="button" class="btn btn-secondary" data-bs-dismiss="modal" id="btncngEmail">{{'CLOSEBTN' | translate}}</button>
            </div>
          </form>
    </div>
  </div>
</div>